import { useContext } from "react";
import {
  TableContext,
  SettingsContext,
  CartContext,
  UserContext,
  CategoriesContext,
  ShopContext,
} from "../App";
import Label from "./Label";
import "../css/Footer.css";
import currencyFormat, { getVisibleCartView } from "./functions/functions";
import CartIcon from "../icons/CartIcon";
import UserIcon from "../icons/UserIcon";
import HomeIcon from "../icons/HomeIcon";
import ListIcon from "../icons/ListIcon";
import TicketIcon from "../icons/TicketIcon";

function Footer() {
  const {
    settings,
    setCartVisible,
    setUserPopupVisible,
    setCourse,
    setCategory,
    setPromoPopup,
    setOrdersVisible,
    monoOrder,
    setLocalHistoryVisible,
  } = useContext(SettingsContext);
  const { table } = useContext(TableContext);
  const { cart } = useContext(CartContext);
  const visibleCart = getVisibleCartView(cart, settings);
  const { user } = useContext(UserContext);
  const { categories } = useContext(CategoriesContext);
  const { shop } = useContext(ShopContext);

  const goToHome = () => {
    if (settings.selfordering.hide_home == 1) {
      if (categories.length > 0) {
        setCourse(categories[0]);
        console.log(categories[0].categories.length);
        if (categories[0].categories.length > 0) {
          console.log(categories[0].categories[0]);
          if (categories[0].categories[0]) setCategory(categories[0].categories[0]);
        }
      }
    } else {
      if (categories && categories.length > 1) setCourse(false);
      setCategory(false);
    }
  };

  return (
    <div className="footer-container">
      {cart && visibleCart.total_items > 0 && (
        <div className="footer-cart">
          <div className="info">
            {settings.selfordering.show_promo == 1 && (
              <button className="promo-button" onClick={() => setPromoPopup(true)}>
                <TicketIcon></TicketIcon>
                <Label number={110} />
              </button>
            )}
            <div className="icon">
              <CartIcon></CartIcon>
              <div className="counter">{visibleCart.total_items}</div>
            </div>
            <span>{currencyFormat(visibleCart.total, false, shop.currency)}</span>
          </div>
          <button
            className="cart-button"
            disabled={cart.closures?.closed == 1}
            onClick={() => setCartVisible(true)}
          >
            <Label number={19} />
          </button>
        </div>
      )}
      <div className="buttons">
        <button onClick={goToHome}>
          <div className="icon">
            <HomeIcon></HomeIcon>
          </div>
          <Label number={108} />
        </button>
        {monoOrder ? (
          <button onClick={() => setLocalHistoryVisible(true)}>
            <div className="icon">
              <ListIcon></ListIcon>
            </div>
            <Label number={76} />
          </button>
        ) : (
          <button onClick={() => setOrdersVisible(true)}>
            <div className="icon">
              <ListIcon></ListIcon>
            </div>
            <Label number={76} />{" "}
            {settings.selfordering.table_label == 1 && (
              <>
                <Label number={22} />{" "}
              </>
            )}
            {table.name}
          </button>
        )}
        <button disabled={cart.closures?.closed == 1} onClick={() => setCartVisible(true)}>
          <div className="icon">
            <CartIcon></CartIcon>
            {cart && <div className="counter">{visibleCart.total_items}</div>}
          </div>
          <Label number={19} />
        </button>
        {settings.selfordering.enable_login == 1 && (
          <button onClick={() => setUserPopupVisible(true)}>
            <div className="icon">
              <UserIcon></UserIcon>
            </div>
            {user ? (
              user.name + " " + user.surname
            ) : (
              <>{settings.selfordering.nicknames == 1 ? cart.nickname : <Label number={23} />}</>
            )}
          </button>
        )}
        {!monoOrder && settings.selfordering.enable_login == 0 && settings.selfordering.nicknames == 1 && (
          <button>
            <div className="icon">
              <UserIcon></UserIcon>
            </div>
            {cart.nickname}
          </button>
        )}
      </div>
      <div className="subfooter">
        {settings.selfordering.hide_list != 1 && cart.list_id && cart.list.name + " - "}
        <Label
          number={152}
          visible={(el) => el != "footer_text"}
          suffix={settings.selfordering.footer_text ? " - " : ""}
        />
        {settings.selfordering.footer_text}
      </div>
    </div>
  );
}

export default Footer;
